import { put, select, take } from 'redux-saga/effects';

import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { openModal } from 'store/modals/actions';
import { CLOSE_MODAL } from 'store/modals/actionTypes';
import { selectDiscountSubscription } from 'store/subscriptions/selectors';

import { ONGOING_EXPERIMENTS } from 'constants/eppo';

import { getStringSafe } from 'services/Eppo';

import { ModalName } from 'modals/types';

import { getCancelSubscriptionSuccessModalData, isCancellationFlowWasApplied } from 'helpers/subscriptions';

import { IDiscountSubscription } from 'types/subscription';

export function* callSuccessCancellingBehaviour({
    cancellationCandidates,
}: {
    cancellationCandidates: ISubscriptionWellfunnel[];
}) {
    yield put(
        openModal(ModalName.SuccessModal, {
            ...getCancelSubscriptionSuccessModalData(cancellationCandidates),
        })
    );

    const testVariant = getStringSafe({ flag: ONGOING_EXPERIMENTS.ReturnOfferAfterCancellation, def: 'default' });

    if (testVariant !== 'a') return;

    const discountSubscription: IDiscountSubscription | null = yield select(selectDiscountSubscription);
    const isExtraOfferAvailable =
        Boolean(discountSubscription) && !isCancellationFlowWasApplied(cancellationCandidates);

    if (isExtraOfferAvailable) {
        yield take(CLOSE_MODAL);
        yield put(
            openModal(ModalName.ReturnModal, {
                isExtraOffer: isExtraOfferAvailable,
            })
        );
    }
}
